import React from 'react';
import nouislider from "nouislider";
import { withStyles } from '@material-ui/core';
import sliderStyle from 'assets/jss/material-dashboard-pro-react/components/sliderStyle.jsx';

class Slider extends React.Component {
    componentDidMount() {
        nouislider.create(this.refs.theSlider, {
            start: [this.props.value || 1],
            connect: [true, false],
            step: this.props.step || 1,
            range: { min: this.props.range[0], max: this.props.range[1] }
        });

        this.refs.theSlider.noUiSlider.on('set', (e) => {
            if (this.props.onSet)
                this.props.onSet(parseInt(e[0]));
        })

        this.refs.theSlider.noUiSlider.on('change', (e) => {
            if (this.props.onChange)
                this.props.onChange(parseInt(e[0]));
        })

        this.refs.theSlider.noUiSlider.on('update', (e) => {
            if (this.props.onUpdate)
                this.props.onUpdate(parseInt(e[0]));
        })
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.value !== this.props.value)
            this.refs.theSlider.noUiSlider.set(newProps.value);
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={"slider-" + (this.props.color ? this.props.color : "primary") + " " + classes.root} ref="theSlider" />
        );
    }
}

export default withStyles(sliderStyle)(Slider);